/* app/js/src/components/recording/recording.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1px;
}
.filter {
  margin-right: 140px;
}
dateinput {
  display: inline-block;
  position: absolute;
}
.recording-container {
  width: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  background-color: #eef2f6;
  overflow-y: hidden;
}
.recording-container .recording-aside {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.recording-container .recording-main {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 16 0 0;
  -ms-flex: 16 0 0;
  flex: 16 0 0;
  padding: 33px 27px 136px 26px;
  width: 900px;
  background-color: white;
}
.recording-container .recording-main .header {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  margin-bottom: 5px;
}
.recording-container .recording-main .header .tabs {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.recording-container .recording-main .header .tabs .tab {
  height: 36px;
  line-height: 36px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: #b9bec9;
  width: 130px;
  border-bottom: 2px solid #f1f3f4;
}
.recording-container .recording-main .header .tabs .tab.active {
  background-color: #f1f3f4 !important;
  border-bottom: 2px solid #40c4ff;
  color: #232f3a;
}
.recording-container .recording-main .header .tabs .tab:hover {
  background-color: #f5f9fd;
}
.recording-container .recording-main .header .tabs .tab:focus {
  outline: none;
}
.recording-container .recording-main .header .add-new-recording,
.recording-container .recording-main .header .refresh-recordings {
  margin-left: 15px;
  background-color: #eef2f6;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 13px;
  width: 137px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
  border-radius: 4px;
}
.recording-container .recording-main .header .add-new-recording .icon,
.recording-container .recording-main .header .refresh-recordings .icon {
  color: #40c4ff !important;
  font-size: 24px;
  flex: 2;
}
.recording-container .recording-main .header .add-new-recording div,
.recording-container .recording-main .header .refresh-recordings div {
  line-height: 35px;
}
.recording-container .recording-main .header .add-new-recording div ::ng-deep svg,
.recording-container .recording-main .header .refresh-recordings div ::ng-deep svg {
  width: 15px;
  height: 15px;
  margin-left: 5px;
}
.recording-container .recording-main .header .add-new-recording span,
.recording-container .recording-main .header .refresh-recordings span {
  -webkit-flex: 6;
  -ms-flex: 6;
  flex: 6;
}
/*# sourceMappingURL=recording.component.css.map */
